import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getByDokumentIdAndDateRange } from "../../services/statistikaDokumenta.service";
import { format, subDays, parseISO } from "date-fns";
import "./ChartDokument.css";

const ChartDokument = ({ dokumentId }) => {
  const [data, setData] = useState([]);
  const colors = ["#f7d6a8", "#ffcfa8", "#ffd1b8", "#fff4b8", "#fff6d9"];

  useEffect(() => {
    if (!dokumentId) return;

    const fetchData = async () => {
      try {
        const endDate = new Date();
        const startDate = subDays(endDate, 6);
        const { data: posjete } = await getByDokumentIdAndDateRange(
          dokumentId,
          format(startDate, "yyyy-MM-dd"),
          format(endDate, "yyyy-MM-dd")
        );

        const last7Days = Array.from({ length: 7 }, (_, i) => {
          const date = format(subDays(endDate, 6 - i), "dd.MM.yyyy.");
          return {
            date,
            posjete: 0,
            fill: colors[i % colors.length],
          };
        });

        posjete.forEach((posjeta) => {
          const rawDate = posjeta.vremenskaOznaka || posjeta.vremenska_oznaka;
          if (!rawDate) return;

          const visitDate = parseISO(rawDate);
          if (isNaN(visitDate)) return;

          const formattedDate = format(visitDate, "dd.MM.yyyy.");
          const found = last7Days.find((item) => item.date === formattedDate);
          if (found) found.posjete += 1;
        });

        setData(last7Days);
      } catch (error) {
      }
    };

    fetchData();
  }, [dokumentId]);

  return (
    <div className="chart-dokument-container">
      <h2 className="chart-dokument-h2">
        Posjećenost dokumenta u zadnjih 7 dana
      </h2>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{ top: 30, right: 30, left: 20, bottom: 60 }}
        >
          <XAxis
            dataKey="date"
            angle={-30}
            textAnchor="end"
            height={60}
            interval={0}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="posjete" name="Broj posjeta">
            {data.map((entry, index) => (
              <cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartDokument;
